<template>
    <div>
        <div @click="getRegions()">
            <span class="ec2Button" @click="modal1 = true">+</span>
        </div>
       <Modal v-model="modal1" title="添加EC2 (服务器实例)" @on-ok="handleSubmit('ElasticComputeCloudForm')" @on-cancel="handleReset('ElasticComputeCloudForm')" width="900px;" :loading="modalLoading" ok-text="添加" :mask-closable="false" :styles="{top:'35px'}" >
            <Form :model="ElasticComputeCloudForm" :label-width="80" ref="ElasticComputeCloudForm" :rules="ruleValidate">
                <!-- 搜索 -->
                <Row>
                    <!-- 地区 -->
                    <Col span="4">
                        <FormItem label="区域 :" style="margin-left: -36px;font-weight: 600;">
                            <div>{{regionDate}}</div>
                        </FormItem>
                    </Col>
                    <!-- 选择操作系统 -->
                    <Col span="10">
                        <FormItem label="操作系统" style="margin-right: 20px;" prop="operatingSystem">
                            <Select v-model="ElasticComputeCloudForm.operatingSystem" @on-change="findOS(ElasticComputeCloudForm.operatingSystem)">
                                <Option :value="item.os" v-for="item in operatingSystemList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- 选择付费类型 -->
                    <Col span="10">
                        <FormItem label="付费类型" prop="costType">
                            <Select v-model="ElasticComputeCloudForm.costType" @on-change="findCostType(ElasticComputeCloudForm.costType)">
                                <Option :value="item.riPaymentOption" v-for="item in costTypeList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    
                </Row>
                <Table :no-data-text="$t('common.noData')" highlight-row ref="selection" :columns="columns4" :loading="loading" :data="elasticComputeCloudData" :height="400" @on-current-change="getSelection"></Table>
                <FormItem>
                    <!-- 北京 -->
                    <div v-show="placeBeijing" style="font-size: 14px;margin-top: 10px;margin-left: -79px;">价格：￥{{priceBeijing}} / <span>月</span> </div>
                    <!-- 新加坡 -->
                    <div v-show="placeSingapore" style="font-size: 14px;margin-top: 10px;margin-left: -79px;">价格：${{priceSingapore}} / <span>月</span> </div>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: 'AddElasticComputeCloud',
        props:['regionDate'],
        data (){
            return {
                preInstalledSoftware:'',
                priceBeijing:'0.00',
                priceSingapore:'0.00',
                placeBeijing:true,
                placeSingapore:true,
                ramSize:'',
                instanceType:'',
                cpuCoreNumber:'',
                cpus:'',
                memorys:'',
                region: '',
                regions:'',
                instanceType:'',
                ElasticComputeCloudForm: {
                    operatingSystem: '2',
                    costType: '0'
                },
                operatingSystemList: [{
                    id: 0,
                    name: 'Windows',
                    os: '1'
                },{
                    id: 1,
                    name: 'WindowsWithSQLEnterprise',
                    os: '3'
                },{
                    id: 2,
                    name: 'WindowsWithSQLStandard',
                    os: '4'
                },{
                    id: 3,
                    name: 'Linux/UNIX',
                    os: '2'
                },{
                    id: 4,
                    name: 'Red Hat Enterprise Linux',
                    os: '0'
                }],
                costTypeList: [{
                    id: 0,
                    name: '按需实例',
                    riPaymentOption: '0'
                },{
                    id: 1,
                    name: '无前期费用(标准1年)',
                    riPaymentOption: '1'
                }],
                selection:[],
                modal1:false,
                modalLoading: true,
                loading: false,
                columns4: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'CPU',
                        key: 'cpuCoreNumber'
                    },
                    {
                        title: '内存',
                        key: 'ramSize'
                    }
                ],
                elasticComputeCloudData: [],
                ruleValidate: {
                    operatingSystem: [
                        { required: true, message: '请选择操作系统', trigger: 'change' }
                    ],
                    costType: [
                        { required: true, message: '请选择付费类型', trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            getRegions: function(){
                if(this.regionDate=='北京'){
                    this.region='CN_NORTH_1';
                    this.placeBeijing=true;
                    this.placeSingapore=false;
                }else if(this.regionDate=='新加坡'){
                    this.region='AP_SOUTHEAST_1';
                    this.placeSingapore=true;
                    this.placeBeijing=false;
                }

                // 查询实例CPU和RAM列表
                /***************************************************************/
                this.loading = true;
                var updateOSData = {
                    "region" : this.region,
                    "term" : this.ElasticComputeCloudForm.costType,
                    "capacityStatus" : 0,
                    "licenseModel" : 0
                };

                // 如果os是WindowsWithSQLEnterprise、WindowsWithSQLStandard     os为1
                if(this.ElasticComputeCloudForm.operatingSystem==3){
                    updateOSData.os = "1";
                    updateOSData.preInstalledSoftware = 1;
                }else if(this.ElasticComputeCloudForm.operatingSystem==4){
                    updateOSData.os = "1";
                    updateOSData.preInstalledSoftware = 3;
                }else if(this.ElasticComputeCloudForm.operatingSystem==1||this.ElasticComputeCloudForm.operatingSystem==2||this.ElasticComputeCloudForm.operatingSystem==0){
                    updateOSData.os =this.ElasticComputeCloudForm.operatingSystem;
                    updateOSData.preInstalledSoftware = 0;
                }
                // 查询当前EC2价格
                if(this.ElasticComputeCloudForm.costType==1){
                    updateOSData.riTenancy = 0;
                    updateOSData.riOfferingClass = 0;
                    updateOSData.leaseContractLength = 0;
                    updateOSData.riPaymentOption = 0;
                }
                
                this.$api.price.listInstanceCoreAndRam(updateOSData)
                .then(res => {
                    this.loading = false;
                    this.elasticComputeCloudData=res.data;
                    for(var i=0;i<this.elasticComputeCloudData.length;i++){
                        this.elasticComputeCloudData[i].cpuCoreNumber=this.elasticComputeCloudData[i].cpuCoreNumber+'核';
                        this.elasticComputeCloudData[i].ramSize=this.elasticComputeCloudData[i].ramSize+'G';
                    }
                })
                    
            },
            // 操作系统
            findOS: function(){
                // 查列表接口
                /***********************************************/
                this.getRegions();
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
            },
            // 付费类型
            findCostType: function(){
                // 查询实例CPU和RAM列表
                this.getRegions();
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
            },
            // 当前选择
            getSelection:function(selection){
                if(selection==null){
                    return;
                }
                this.ramSize=selection.ramSize;
                this.cpus=selection.cpuCoreNumber;
                this.cpus=this.cpus.replace('核',"");
                this.memorys=selection.ramSize;
                this.memorys=this.memorys.replace('G',"");
                var updateOSData = {
                    "region" : this.region,
                    "cpuCoreNumber" : this.cpus,
                    "ramSize" : this.memorys,
                    "term" : this.ElasticComputeCloudForm.costType,
                    "capacityStatus" : 0,
                    "licenseModel" : 0
                };
                // 如果os是WindowsWithSQLEnterprise、WindowsWithSQLStandard     os为1
                if(this.ElasticComputeCloudForm.operatingSystem==3){
                    updateOSData.os = "1";
                    updateOSData.preInstalledSoftware = 1;
                }else if(this.ElasticComputeCloudForm.operatingSystem==4){
                    updateOSData.os = "1";
                    updateOSData.preInstalledSoftware = 3;
                }else if(this.ElasticComputeCloudForm.operatingSystem==1||this.ElasticComputeCloudForm.operatingSystem==2||this.ElasticComputeCloudForm.operatingSystem==0){
                    updateOSData.os =this.ElasticComputeCloudForm.operatingSystem;
                    updateOSData.preInstalledSoftware = 0;
                }
                // 查询当前EC2价格
                if(this.ElasticComputeCloudForm.costType==1){
                    updateOSData.riTenancy = 0;
                    updateOSData.riOfferingClass = 0;
                    updateOSData.leaseContractLength = 0;
                    updateOSData.riPaymentOption = 0;
                }
                this.$api.price.getInstancePrice(updateOSData)
                .then(res => {
                    //北京
                    this.priceBeijing=res.data.monthlyCostByRMB.toFixed(2);
                    //新加坡
                    this.priceSingapore=res.data.monthlyCostByDollars.toFixed(2);
                    //实例类型
                    this.instanceType=res.data.instanceType;
                    //区域
                    this.regions=res.data.region;
                    //预装软件
                    this.preInstalledSoftware=res.data.preInstalledSoftware;
                })
                .catch(err=>{
                    this.priceBeijing="0.00";
                    this.priceSingapore="0.00";
                })
            },
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid&&this.ramSize!=''&&this.priceBeijing!=0.00||this.priceSingapore!=0.00) {
                        var EC2ListCopy=new Object();
                        EC2ListCopy.region=this.regionDate;
                        EC2ListCopy.cpuCoreNumber=this.cpus;
                        EC2ListCopy.ramSize=this.memorys;
                        EC2ListCopy.os=this.ElasticComputeCloudForm.operatingSystem;
                        EC2ListCopy.paymentType=this.ElasticComputeCloudForm.costType;
                        EC2ListCopy.number=1;
                        EC2ListCopy.month=1;
                        EC2ListCopy.usage='';
                        EC2ListCopy.instanceType=this.instanceType;
                        EC2ListCopy.preInstalledSoftware=this.preInstalledSoftware;
                        EC2ListCopy.regions=this.regions;
                        EC2ListCopy.priceBeijing=this.priceBeijing;
                        EC2ListCopy.priceSingapore=this.priceSingapore;
                        // 传值
                        this.$emit('addEC2CallBack',EC2ListCopy);
                        setTimeout(() => {
                            this.modalLoading = false;
                            this.$nextTick(() => {
                                this.modalLoading = true;
                            });
                            this.ramSize='';
                            this.priceBeijing="0.00";
                            this.priceSingapore="0.00";
                            this.$refs.selection.clearCurrentRow();                             
                            this.$Message.success('添加成功');    
                            this.modal1 = false;
                        },1000);                 
                    }                     
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                    }
                });
            },
            handleReset: function(name) {
                this.ramSize='';
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
                this.$refs.selection.clearCurrentRow();
            }
        }
    }
</script>

<style scoped>
    .ec2Button
    {
        float: right;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: block;
        background-color: #2db7f5;
        text-align: center;
        line-height: 25px;
        color: #fff;
        font-size: 19px;
        margin-top: 7px;
        margin-right: 10px;
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_calculation/AddElasticComputeCloud.vue